module.exports = {"text1":"We provide training software both for your PC and also mobile for iOS and Android. For the best training results we recommend using both a PC and also our app.","text2":"Our goal is that you train efficiently with new methods and modern technology. Novel pattern based training method Comprehensive chess training. Personalized and adaptive!","text3":"We leverage state of the art technology with the goal to enable you to become the best possible version of yourself! Be the best chess player you can be!"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/softwares/en/texts.yml
// module id = 983
// module chunks = 14633198248673